import { useEffect } from 'react';
import { useAuthStore } from '../stores/useAuthStore';

const HEARTBEAT_INTERVAL_MS = 60000;

export function useSessionHeartbeat() {
  const user = useAuthStore((state) => state.user);
  const updateOnlineStatus = useAuthStore((state) => state.updateOnlineStatus);

  useEffect(() => {
    if (!user?.id) {
      return undefined;
    }

    const sendHeartbeat = async () => {
      try {
        await updateOnlineStatus();
      } catch {
        // Auth failures are handled centrally by authRequest.
      }
    };

    sendHeartbeat();

    const intervalId = window.setInterval(() => {
      sendHeartbeat();
    }, HEARTBEAT_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [updateOnlineStatus, user?.id]);
}
